import storage from 'helpers/storage';
import { clearAuthToken } from 'helpers/authToken';
import { signOut, auth } from 'services/firebase';
import { clearRequestCache } from 'services/api';

export const logout = () => {
  // Fire-and-forget: clear the server-side session cookie AND Firebase client
  // state so neither can revive the other. Callers treat logout as a plain
  // action creator (dispatched or even called bare), so we keep the
  // synchronous return type and swallow the async settlement.
  signOut(auth).catch((err) => console.error('Firebase signOut failed:', err));
  clearAuthToken().catch((err) => console.error('clear session failed:', err));
  // Anonymous users still use the legacy localStorage token — clear it.
  storage.removeItem('token');
  clearRequestCache();
  return { type: 'LOGOUT' };
};
